/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dropdown-div{width:200px}.ms-PeoplePicker{width:100%}.controlledPickerButton{height:auto}\n"}]);